<template>
  <div>
    <!-- Video -->
    <video-view
      video-id="https://vimeo.com/625577468/47d3ed3bf5"
      variant="is-greenish"
    >
      <!-- Title (first) -->
      <template slot="title-first">
        <div>
          {{ $t('header_8_1') }}
          <div class="underline">
            {{ $t('header_8_2') }}
          </div>
          <br>
          {{ $t('header_8_3') }}
        </div>
      </template>

      <!-- Video -->
      <video
        autoplay
        muted
        loop
        playsinline
      >

        <source
          type="video/mp4"
          src="https://media.blissapplications.com/videos/desktop-1440-clip-work.mp4"
        >

      </video>
    </video-view>

    <!-- Title -->
    <title-view variant="primary">
      {{ $t('work_2') }}
    </title-view>

    <!-- Subtitle -->
    <div class="has-max-width">
      <title-view variant="subtitle">
        <span>
          {{ $t('work_11') }}
        </span>
      </title-view>
    </div>
    <div>
      <ul class="cases-filter">
        <template v-for="tag in availableTags">
          <li
            :key="tag.slug"
            class="cases-filter__list"
          >
            <a
              class="cases-filter__tag"
              :class="{'cases-filter__tag--active': activeTags.includes(tag.slug)}"
              @click="filterCases(tag.slug)"
            >{{ tag.name }}</a>
          </li>
        </template>
      </ul>
    </div>
    <!-- Videos -->
    <div
      class="grid-2-center center"
    >
      <card-case-view
        v-for="(caseStudy, index) in filteredCases"
        :key="index"
        class="col-5_sm-12"
        @click="goToDetails(caseStudy.slug)"
      >
        <template slot="image">
          <picture>
            <source
              media="--small"
              :data-srcset="caseStudy.mobileimage.url"
            >

            <source
              media="--large"
              :data-srcset="caseStudy.image.url"
            >

            <img
              class="lazyload"
              data-sizes="auto"
              :data-src="caseStudy.image.url"
            >
          </picture>
        </template>
        <template slot="title">
          {{ caseStudy.client }}
        </template>

        <template slot="subtitle">
          {{ caseStudy.name }}
        </template>
      </card-case-view>
    </div>

    <footer-contact-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ENVIRONMENT from '@/env';

export default {
  name: 'PageWork',
  components: {
    TitleView: () => import('@/components/title/title-view'),
    VideoView: () => import('@/components/video/video-view'),
    CardCaseView: () => import('@/components/card/card-case-view'),
    FooterContactView: () => import('@/components/footer/footer-contact-view')
  },
  data() {
    return {
      activeTags: [],
      isActive: null
    };
  },
  metaInfo: {
    title: 'Work: We build digital solutions that deliver measurable results to help meet your business goals',
    meta: [
      {
        name: 'description',
        content: 'We partner with our clients and focus on the user experience to deliver exceptional innovative digital solutions.'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/work'
      },
      {
        property: 'og:title',
        content: 'Work: We build digital solutions that deliver measurable results to help meet your business goals'
      },
      {
        property: 'og:description',
        content: 'We partner with our clients and focus on the user experience to deliver exceptional innovative digital solutions.'
      },
      {
        property: 'og:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      },
      {
        name: 'twitter:title',
        content: 'Work: We build digital solutions that deliver measurable results to help meet your business goals'
      },
      {
        name: 'twitter:description',
        content: 'We partner with our clients and focus on the user experience to deliver exceptional innovative digital solutions.'
      },
      {
        name: 'twitter:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      }
    ]
  },

  computed: {
    ...mapState('cases', {
      cases: (state) => state.cases
    }),
    baseUrl() {
      return ENVIRONMENT.baseUrl;
    },
    availableTags() {
      if (!this.cases.length) {
        return [];
      }

      const tags = this.cases.reduce((memo, current) => {
        current.tags.forEach((item) => {
          if (!memo.find((t) => t.slug === item.TagSlug)) {
            memo.push({
              name: item.TagName,
              slug: item.TagSlug
            });
          }
        });
        return memo;
      }, []);

      // eslint-disable-next-line
      return tags.sort((a, b) => (a.name > b.name) ? 1 : -1);
    },
    filteredCases() {
      if (!this.activeTags.length) {
        return this.cases;
      }
      return this.cases.filter((c) => !!c.tags.some((t) => this.activeTags.includes(t.TagSlug)));
    }

  },

  mounted() {
    this.getCases();
  },

  methods: {
    ...mapActions('cases', [
      'getCases'
    ]),

    goToDetails(caseSlug) {
      this.$router.push({ name: 'work_show', params: { id: caseSlug } });
    },
    filterCases(slug) {
      if (!this.activeTags.includes(slug)) {
        this.activeTags.push(slug);
      } else {
        this.activeTags.splice(this.activeTags.indexOf(slug), 1);
      }
    }
  }
};
</script>
<style lang="scss" src="@/assets/pages/cases-filter.scss"></style>



// WEBPACK FOOTER //
// index.vue